<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData" v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>
          <!-- <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd1">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">删除</el-button> -->
          <!-- <el-dropdown v-if="tableAcl.indexOf('Print') != -1" @command="printList">
            <el-button v-if="tableAcl.indexOf('Print') != -1" class="btn primary" type="primary">
              打印
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="0">打印</el-dropdown-item>
              <el-dropdown-item command="1">预览</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
          @click="showTransfer">自定义设置</el-button>
        </div>
      </div>

      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
        
        </CustomTable>
    </div>
    <div v-else>
      <el-table ref="multipleTable" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" border :data="tableData" :max-height="tableHeight" :summary-method="getSummaries" show-summary style="width: 100%" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>

        <el-table-column show-overflow-tooltip width="170" prop="supplierProductNo" label="供应商产品编码"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" width="140" prop="productName" label="产品名称"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" width="140" prop="specName" label="规格型号"></el-table-column>
        <el-table-column show-overflow-tooltip width="120" prop="warehouseName" label="库房"></el-table-column>
        <el-table-column width="50" prop="unit" label="单位"></el-table-column>
        <el-table-column show-overflow-tooltip width="160" prop="manufacturerName" label="生产厂家"></el-table-column>
        <el-table-column label="期初库存" align="center">
          <el-table-column width="120" prop="startStockNumber" label="数量"></el-table-column>
          <el-table-column width="120" prop="startStockAmount" label="金额"></el-table-column>
        </el-table-column>

        <el-table-column label="采购入库(含退库)" align="center" v-if="this.warehouseLevel == 1">
          <el-table-column width="120" prop="purchaseInStockNumber" label="数量"></el-table-column>
          <el-table-column width="120" prop="purchaseInStockAmount" label="金额"></el-table-column>
        </el-table-column>
        <el-table-column label="科室入库(含退库)" align="center" v-if="this.warehouseLevel == 2">
          <el-table-column width="120" prop="deptInStockNumber" label="数量"></el-table-column>
          <el-table-column width="120" prop="deptInStockAmount" label="金额"></el-table-column>
        </el-table-column>
        <el-table-column label="调拨入库" align="center">
          <el-table-column width="120" prop="transferInStockNumber" label="数量"></el-table-column>
          <el-table-column width="120" prop="transferInStockAmount" label="金额"></el-table-column>
        </el-table-column>
        <el-table-column label="请领出库(含退库)" align="center" v-if="this.warehouseLevel == 1">
          <el-table-column width="120" prop="applyOutStockNumber" label="数量"></el-table-column>
          <el-table-column width="120" prop="applyOutStockAmount" label="金额"></el-table-column>
        </el-table-column>
        <el-table-column label="领用出库(含退库)" align="center" v-if="this.warehouseLevel == 2">
          <el-table-column width="120" prop="celloctOutStockNumber" label="数量"></el-table-column>
          <el-table-column width="120" prop="celloctOutStockAmount" label="金额"></el-table-column>
        </el-table-column>
        <el-table-column label="调拨出库" align="center">
          <el-table-column width="120" prop="transferOutStockNumber" label="数量"></el-table-column>
          <el-table-column width="120" prop="transferOutStockAmount" label="金额"></el-table-column>
        </el-table-column>
        <el-table-column label="报损" align="center">
          <el-table-column width="120" prop="lossesNumber" label="数量"></el-table-column>
          <el-table-column width="120" prop="lossesAmount" label="金额"></el-table-column>
        </el-table-column>
        <el-table-column label="盘盈盘亏" align="center">
          <el-table-column width="120" prop="profitAndLossNumber" label="数量"></el-table-column>
          <el-table-column width="120" prop="profitAndLossAmount" label="金额"></el-table-column>
        </el-table-column>
        <el-table-column label="期初录入" align="center">
          <el-table-column width="120" prop="periodStockNumber" label="数量"></el-table-column>
          <el-table-column width="120" prop="periodStockAmount" label="金额"></el-table-column>
        </el-table-column>
        <el-table-column width="120" prop="gainsLossAmount" label="损益金额"></el-table-column>
        <!-- <el-table-column label="本期总入库" align='center'>
          <el-table-column width="120" prop="inStockNumber" label="数量"></el-table-column>
          <el-table-column width="120" prop="inStockAmount" label="金额"></el-table-column>
        </el-table-column>
        <el-table-column label="本期总出库" align='center'>
          <el-table-column width="120" prop="outStockNumber" label="数量"></el-table-column>
          <el-table-column width="120" prop="outStockAmount" label="金额"></el-table-column>
        </el-table-column> -->
        <el-table-column width="120" prop="exceptionNumber" label="异常数量"></el-table-column>
        <el-table-column width="120" prop="exceptionAmount" label="异常金额"></el-table-column>

        <el-table-column label="期末库存" align="center">
          <el-table-column width="120" prop="endStockNumber" label="数量"></el-table-column>
          <el-table-column width="120" prop="endStockAmount" label="金额"></el-table-column>
        </el-table-column>
        <el-table-column show-overflow-tooltip width="160" prop="inventoryTurnDays" label="周转天数"></el-table-column>
        <el-table-column show-overflow-tooltip width="160"  prop="inventoryTurnRate" label="周转率"></el-table-column>
      </el-table>
    </div>
   
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import { GetStockBalancePrintData, GetAutobalances, ExportAutobalance } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import SelectFilter from "@/components/table-select-filter";
// import BaseListMixin from '@/mixin/baseList-mixin.js'

export default {
  mixins: [GetDataSpdMixin, GetDataMixin], //BaseListMixin
  components: {
    SelectFilter,
  },
  data () {
    return {
      // GetDatasAction: GetAutobalances,
      exportAction: ExportAutobalance,
      filterOptions: [
        // {
        //   name: "产品或规格",
        //   type: "input",
        //   code: "keyWord"
        // },
        {
          name: "生产厂家",
          type: "select",
          code: "manufacturerId",
          filterMethod: this.getManufacturers,
          data: [],
        },
        {
          name: "供应商",
          type: "select",
          code: "supplierId",
          filterMethod: this.getSuppliers,
          data: [],
        },
        {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo",
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName",
        },
        {
          name: "库房",
          type: "select",
          code: "warehouseId",
          filterMethod: this.getWarehouses,
          data: [],
        },
        {
          name: "日期范围",
          type: "datetimerange",
          code: "date",
          format:'yyyy-MM-dd HH:mm:ss',
        },
      ],
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // 新增、编辑的数据
      form: {},
      loading: false,
      editMode: false,
      stockBalanceLogList: [],
      tableData: [],
      totalData: [],
      productPageTotal: 0,
      patientPageTotal: 0,
      total: 0,
      query: {
        pageIndex: 1,
        pageSize: 10,
      },
      startTotalNumber: 0,
      startTotalAmount: 0,
      inTotalNumber: 0,
      inTotalAmount: 0,
      outTotalNumber: 0,
      outTotalAmount: 0,
      endTotalNumber: 0,
      endTotalAmount: 0,
      gainsLossTotalAmount: 0,
      warehouseLevel: 0,

      purchaseInTotalNumber: 0,
      purchaseInTotalAmount: 0,
      deptInTotalNumber: 0,
      deptInTotalAmount: 0,
      transferInTotalNumber: 0,
      transferInTotalAmount: 0,
      transferOutTotalNumber: 0,
      transferOutTotalAmount: 0,
      celloctOutTotalNumber: 0,
      celloctOutTotalAmount: 0,
      applyOutTotalNumber: 0,
      applyOutTotalAmount: 0,
      lossesTotalNumber: 0,
      lossesTotalAmount: 0,
      profitAndLossTotalAmount: 0,
      profitAndLossTotalNumber: 0,
      periodTotalNumber: 0,
      periodTotalAmount: 0,
    };
  },
  methods: {
    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        } else if (column.property === "startStockNumber") {
          sums[index] = this.startTotalNumber;
        } else if (column.property === "startStockAmount") {
          sums[index] = this.startTotalAmount + " 元";
        } else if (column.property === "inStockNumber") {
          sums[index] = this.inTotalNumber;
        } else if (column.property === "inStockAmount") {
          sums[index] = this.inTotalAmount + " 元";
        } else if (column.property === "outStockNumber") {
          sums[index] = this.outTotalNumber;
        } else if (column.property === "outStockAmount") {
          sums[index] = this.outTotalAmount + " 元";
        } else if (column.property === "endStockNumber") {
          sums[index] = this.endTotalNumber;
        } else if (column.property === "endStockAmount") {
          sums[index] = this.endTotalAmount + " 元";
        } else if (column.property === "gainsLossAmount") {
          sums[index] = this.gainsLossTotalAmount + " 元";
        } else if (column.property === "purchaseInStockNumber") {
          sums[index] = this.purchaseInTotalNumber;
        } else if (column.property === "purchaseInStockAmount") {
          sums[index] = this.purchaseInTotalAmount + " 元";
        } else if (column.property === "deptInStockNumber") {
          sums[index] = this.deptInTotalNumber;
        } else if (column.property === "deptInStockAmount") {
          sums[index] = this.deptInTotalAmount + " 元";
        } else if (column.property === "transferInStockNumber") {
          sums[index] = this.transferInTotalNumber;
        } else if (column.property === "transferInStockAmount") {
          sums[index] = this.transferInTotalAmount + " 元";
        } else if (column.property === "transferOutStockNumber") {
          sums[index] = this.transferOutTotalNumber;
        } else if (column.property === "transferOutStockAmount") {
          sums[index] = this.transferOutTotalAmount + " 元";
        } else if (column.property === "celloctOutStockNumber") {
          sums[index] = this.celloctOutTotalNumber;
        } else if (column.property === "celloctOutStockAmount") {
          sums[index] = this.celloctOutTotalAmount + " 元";
        } else if (column.property === "applyOutStockNumber") {
          sums[index] = this.applyOutTotalNumber;
        } else if (column.property === "applyOutStockAmount") {
          sums[index] = this.applyOutTotalAmount + " 元";
        } else if (column.property === "lossesNumber") {
          sums[index] = this.lossesTotalNumber;
        } else if (column.property === "lossesAmount") {
          sums[index] = this.lossesTotalAmount + " 元";
        } else if (column.property === "profitAndLossNumber") {
          sums[index] = this.profitAndLossTotalNumber;
        } else if (column.property === "profitAndLossAmount") {
          sums[index] = this.profitAndLossTotalAmount + " 元";
        } else if (column.property === "periodStockNumber") {
          sums[index] = this.periodTotalNumber;
        } else if (column.property === "periodStockAmount") {
          sums[index] = this.periodTotalAmount + " 元";
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    // 编辑
    handleInfo1 (row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      this.open = true;
      this.title = "查看";
      this.editMode = false;
    },
    resetForm () {
      this.form = {
        id: 0,
        warehouseId: "",
        startDate: "",
        endDate: "",
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      this.open = false;
    },
    getData () {
      this.loading = true;
      GetAutobalances(this.query)
        .then((res) => {
          if (res.successful) {
            console.log(res, "res");
            this.totalData = res.returnData.data;
            this.total = this.totalData ? this.totalData.length : 0;
            this.tableData = this.getPaginationData(
              this.totalData,
              this.query.pageIndex,
              this.query.pageSize
            );
            this.startTotalNumber = res.returnData.dataTotalObj.startTotalNumber;
            this.startTotalAmount = res.returnData.dataTotalObj.startTotalAmount;
            this.inTotalNumber = res.returnData.dataTotalObj.inTotalNumber;
            this.inTotalAmount = res.returnData.dataTotalObj.inTotalAmount;
            this.outTotalNumber = res.returnData.dataTotalObj.outTotalNumber;
            this.outTotalAmount = res.returnData.dataTotalObj.outTotalAmount;
            this.endTotalNumber = res.returnData.dataTotalObj.endTotalNumber;
            this.endTotalAmount = res.returnData.dataTotalObj.endTotalAmount;
            this.gainsLossTotalAmount = res.returnData.dataTotalObj.gainsLossTotalAmount;
            this.warehouseLevel = res.returnData.dataTotalObj.warehouseLevel;

            this.purchaseInTotalNumber =
              res.returnData.dataTotalObj.purchaseInTotalNumber;
            this.purchaseInTotalAmount =
              res.returnData.dataTotalObj.purchaseInTotalAmount;
            this.deptInTotalNumber = res.returnData.dataTotalObj.deptInTotalNumber;
            this.deptInTotalAmount = res.returnData.dataTotalObj.deptInTotalAmount;
            this.transferInTotalNumber =
              res.returnData.dataTotalObj.transferInTotalNumber;
            this.transferInTotalAmount =
              res.returnData.dataTotalObj.transferInTotalAmount;
            this.transferOutTotalNumber =
              res.returnData.dataTotalObj.transferOutTotalNumber;
            this.transferOutTotalAmount =
              res.returnData.dataTotalObj.transferOutTotalAmount;
            this.celloctOutTotalNumber =
              res.returnData.dataTotalObj.celloctOutTotalNumber;
            this.celloctOutTotalAmount =
              res.returnData.dataTotalObj.celloctOutTotalAmount;
            this.applyOutTotalNumber = res.returnData.dataTotalObj.applyOutTotalNumber;
            this.applyOutTotalAmount = res.returnData.dataTotalObj.applyOutTotalAmount;
            this.lossesTotalNumber = res.returnData.dataTotalObj.lossesTotalNumber;
            this.lossesTotalAmount = res.returnData.dataTotalObj.lossesTotalAmount;
            this.profitAndLossTotalAmount =
              res.returnData.dataTotalObj.profitAndLossTotalAmount;
            this.profitAndLossTotalNumber =
              res.returnData.dataTotalObj.profitAndLossTotalNumber;
            this.periodTotalNumber = res.returnData.dataTotalObj.periodTotalNumber;
            this.periodTotalAmount = res.returnData.dataTotalObj.periodTotalAmount;
          } else {
            this.$message.error(`${res.errorMessage}`);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getPaginationData (list, pageIndex, pageSize) {
      return list.slice((pageIndex - 1) * pageSize, pageIndex * pageSize);
    },

    printList (command) {
      this.query.type = command;

      // GetStockBalancePrintData(this.query)
      //   .then(res => {
      //     var result = res.returnData

      //     var printData = this.printDataConvert(result.printData)
      //     this.sendPrintMessage(JSON.stringify(printData));
      //   })
    },

    // getStockBalanceLogList (keyWord) {
    //   return new Promise((resolve, reject) => {
    //     GetStockBalanceLog({ keyWord: keyWord, pageIndex: 1, pageSize: 100 }).then((response) => {
    //       if (response && response.returnData) {
    //         this.stockBalanceLogList = response.returnData.data
    //         this.stockBalanceLogList.map(item => {
    //           item.name = `${item.warehouseName} ${this.parseTime(new Date(item.startDate), "{y}-{m}-{d}")}至${this.parseTime(new Date(item.endDate), "{y}-{m}-{d}")}`
    //           return item;
    //         })
    //         resolve(this.stockBalanceLogList);
    //       } else {
    //         reject(response);
    //       }
    //     });
    //   });

    // }

    // 重置
    reset () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.getData();
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.tableData = this.getPaginationData(
        this.totalData,
        this.query.pageIndex,
        this.query.pageSize
      );
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.tableData = this.getPaginationData(
        this.totalData,
        this.query.pageIndex,
        this.query.pageSize
      );
    },
  },
  created () {
    // this.query.viewMode = 0
  },
  mounted () {
    this.$refs["selectFilter"].query.viewMode = 0;
    // this.getData('');
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table__header-wrapper {
  height: 100% !important;
}
// /deep/.el-table--border .el-table__cell {
//   border-right: 0px !important;
// }
/deep/.el-dialog__body {
  overflow: auto !important;
}
</style>
